var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailMsgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63636 21.0021H5.45456V11.7294L2.95434 7.36353L0 7.63845V19.3657C0 20.2698 0.732281 21.0021 1.63636 21.0021Z",
    fill: "#0085F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 21.0021H22.3636C23.2677 21.0021 24 20.2698 24 19.3657V7.63845L21.0499 7.36353L18.5455 11.7294V21.0021H18.5454Z",
    fill: "#00A94B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5456 4.63856L16.3027 8.91839L18.5456 11.7295L24.0001 7.63856V5.45676C24.0001 3.43448 21.6915 2.27948 20.0728 3.49312L18.5456 4.63856Z",
    fill: "#FFBC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45455 11.7296L3.31738 7.21506L5.45455 4.63867L12 9.54775L18.5454 4.63867V11.7296L12 16.6387L5.45455 11.7296Z",
    fill: "#FF4131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.45676V7.63856L5.45456 11.7295V4.63856L3.92728 3.49312C2.30864 2.27948 0 3.43448 0 5.45676Z",
    fill: "#E51C19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailMsgIcon);
export default __webpack_public_path__ + "static/media/gmailMsgIcon.e11764ee851c23dc2c4162d2326a6405.svg";
export { ForwardRef as ReactComponent };